import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import queryString from 'query-string';

import { Switch } from 'ui/components/Switch';

import { useQuery } from 'hooks';

import { RowWrapper, RowLabel } from 'ui/components/Filters/styled';

export const ToggleFilter: FC<Props> = ({
  label,
  name,
  withFalse = false,
  reverseValue = false,
}) => {
  const { query, replaceQuery } = useQuery();
  const location = useLocation();

  const parsedQuery = queryString.parse(location.search);
  const activeValue = reverseValue ? 'false' : 'true';

  const [isActive, setIsActive] = useState(parsedQuery[name] === activeValue);

  useEffect(() => {
    const query = queryString.parse(location.search);

    setIsActive(query[name] === activeValue);
  }, [name, location.search, activeValue]);

  const onChange = (value: boolean) => {
    const { page } = query;
    const toggleValue = reverseValue
      ? withFalse
        ? !value
        : !value && undefined
      : withFalse
        ? value
        : value || undefined;

    setIsActive(value);
    replaceQuery({ [name]: toggleValue, page: page ? 1 : undefined });
  };

  return (
    <RowWrapper>
      <Switch size='small' checked={isActive} onChange={onChange} />
      <RowLabel>{label}</RowLabel>
    </RowWrapper>
  );
};

type Props = {
  label: string;
  name: string;
  withFalse?: boolean;
  reverseValue?: boolean;
};
